import { render, staticRenderFns } from "./edit-contact.vue?vue&type=template&id=0463e6ef&"
import script from "./edit-contact.vue?vue&type=script&lang=js&"
export * from "./edit-contact.vue?vue&type=script&lang=js&"
import style0 from "./edit-contact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports